import { Close } from '@mui/icons-material';
import { Box, Grid, IconButton, Modal, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import AryLoadingButton from './AryLoadingButton';

const AryModal = ({
  open,
  handleClose,
  title,
  noCloseOnOutsideClicked,
  noCloseIcon,
  width,
  height,
  overflow,
  justifyContent,
  alignItems,
  rowSpacing,
  columnSpacing,
  descriptionSpacingToTitle,
  style,
  titleColor,
  footer,
  hidden = false,
  children
}) => {
  const theme = useTheme();

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width || '46.875rem',
    maxHeight: '95vh',
    height: height || 'auto',
    maxWidth: '95vw',
    backgroundColor: 'background.paper',
    borderRadius: '0.25rem',
    boxShadow: 24,
    p: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    ...style
  };

  return (
    <Modal
      open={open}
      onClose={noCloseOnOutsideClicked ? () => {} : handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          handleClose();
        }
      }}
      sx={{
        display: hidden ? 'none' : 'flex'
      }}
    >
      <Box sx={modalStyle}>
        <Grid
          container
          id="modal-modal-title"
          justifyContent="center"
          alignItems="center"
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: 'white',
            pb: 0,
            pt: '1.5rem',
            px: '1.5rem'
          }}
        >
          <Grid item flexGrow={1}>
            <Typography color={titleColor} variant="h3Heavy">
              {title}
            </Typography>
          </Grid>
          {!noCloseIcon && (
            <Grid item>
              <IconButton onClick={handleClose} tabIndex={-1}>
                <Close />
              </IconButton>
            </Grid>
          )}
        </Grid>

        <Box
          sx={{
            overflowY: overflow || 'auto',
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            minHeight: 0,
            px: '1.5rem',
            py: '1.5rem',
            mt: descriptionSpacingToTitle || '1rem'
          }}
        >
          <Grid
            container
            rowSpacing={rowSpacing || theme.padding?.gridRowSpacing}
            columnSpacing={columnSpacing || theme.padding?.gridColumnSpacing}
            justifyContent={justifyContent}
            alignItems={alignItems}
          >
            {children}
          </Grid>
        </Box>

        {footer && (
          <Box
            sx={{
              flexShrink: 0,
              zIndex: 10,
              backgroundColor: 'white',
              p: '1.5rem'
            }}
          >
            <Stack direction="row" justifyContent="flex-end" gap="0.75rem">
              {footer.ghostButton && (
                <AryLoadingButton
                  variant="text"
                  loading={footer.ghostButton.loading || false}
                  disabled={footer.ghostButton.disabled || false}
                  onClick={footer.ghostButton.onClick}
                  type={footer.ghostButton.type}
                  form={footer.ghostButton.form}
                  {...footer.ghostButton.props}
                >
                  {footer.ghostButton.text}
                </AryLoadingButton>
              )}
              {footer.outlinedButton && (
                <AryLoadingButton
                  variant="outlined"
                  loading={footer.outlinedButton.loading || false}
                  disabled={footer.outlinedButton.disabled || false}
                  onClick={footer.outlinedButton.onClick}
                  type={footer.outlinedButton.type}
                  form={footer.outlinedButton.form}
                  {...footer.outlinedButton.props}
                >
                  {footer.outlinedButton.text}
                </AryLoadingButton>
              )}
              {footer.defaultButton && (
                <AryLoadingButton
                  variant="contained"
                  loading={footer.defaultButton.loading || false}
                  disabled={footer.defaultButton.disabled || false}
                  onClick={footer.defaultButton.onClick}
                  type={footer.defaultButton.type}
                  form={footer.defaultButton.form}
                  {...footer.defaultButton.props}
                >
                  {footer.defaultButton.text}
                </AryLoadingButton>
              )}
            </Stack>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default AryModal;
